'use client';

import type { ReactEventHandler, ReactNode } from 'react';
import Button, { ButtonVariants } from '@pixum/button';

interface ProceedButtonProps {
  children: ReactNode;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariants;
  isBusy?: boolean;
  isClickable?: boolean;
  disabled?: boolean;
  onClick?: ReactEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export function ProceedButton({
  children,
  href,
  type = 'button',
  variant = ButtonVariants.PRIMARY,
  isBusy,
  isClickable,
  disabled,
  onClick
}: ProceedButtonProps) {
  return (
    <Button
      href={href}
      type={type}
      variant={variant}
      isBusy={isBusy}
      isClickable={isClickable}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
